<script setup lang="ts">
import debounce from 'lodash.debounce';
import { faArrowUp } from '@fortawesome/pro-regular-svg-icons';

const { threshold = 200 } = defineProps<{
    threshold?: number;
}>();

const hide = ref(true);
const scrollToTop = () =>
    window.scrollTo({
        top: 0,
        behavior: 'smooth',
    });

const scrollDebounced = debounce(
    () => {
        hide.value = window.scrollY <= threshold;
    },
    200,
    {
        leading: true,
        trailing: true,
        maxWait: 200,
    }
);

onMounted(() => window.addEventListener('scroll', scrollDebounced));

onBeforeUnmount(() => window.removeEventListener('scroll', scrollDebounced));
</script>

<template>
    <mr-button
        :icon-button="faArrowUp"
        class="icon"
        :class="{ hide }"
        @click="scrollToTop"
    />
</template>
<style lang="scss" scoped>
.icon {
    z-index: 10000;
    position: fixed !important;
    bottom: 40px;
    right: 40px;
    @include mobile-only {
        bottom: 20px;
        right: 20px;
    }
    transform: scale(1);
    transition: transform 200ms ease-in-out;
    &.hide {
        transform: scale(0);
    }
}
</style>
